import { IBidderLabel, transformBidderLabelFromAPI } from '~/src/dash/api/console-api';
import { generateTokenParams, IHttpResponse, restGet } from '~/src/dash/api/rest';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { getApiDomain } from '~/src/dash/resellers/utils/importResellerConfig';
import { IMenuList } from '~/src/dash/types/menuList';
import { obfuscateBidderLabels } from '~/src/dash/utils/obfuscate';

export async function getBidderLabelsAsIMenuList(
  session: ISessionState,
  user: IUserState,
): Promise<Record<string, IMenuList>> {
  const reqUrl = `${getApiDomain()}/v1/settings/bidder_label?${generateTokenParams(
    session.publisher.ID,
  )}`;
  return await restGet<any>(reqUrl, {})
    .then((val: IHttpResponse<any>) => {
      const bidderLabels = val.parsedBody?.map(transformBidderLabelFromAPI);
      return {
        bidderLabels: generateBidderLabelMenuList(bidderLabels, [], user.user.Username),
      };
    })
    .catch((e) => {
      console.error(e);
      return {
        bidderLabels: {},
      };
    });
}

const generateBidderLabelMenuList = (
  bidderLabels: IBidderLabel[],
  selectedIDs: string[],
  username: string,
): IMenuList => {
  const menuList: IMenuList = {};

  bidderLabels.forEach((bidderLabel: IBidderLabel) => {
    menuList[bidderLabel.ID] = {
      ID: bidderLabel.ID.toString(),
      selected: selectedIDs.includes(bidderLabel.ID.toString()),
      title: obfuscateBidderLabels(
        bidderLabel,
        username,
        `[${bidderLabel.ID}] ${bidderLabel.Name}`,
      ),
    };
  });

  return menuList;
};
